import { Link } from "react-router-dom";

export default function Configuracion() {
  return (
    <div className="container-fluid py-4 text-dark">
      {/* Migas */}
      <ol className="breadcrumb float-xl-end">
        <li className="breadcrumb-item">
          <Link to="/devioz/dashboard">Dashboard</Link>
        </li>
        <li className="breadcrumb-item active">Configuración</li>
      </ol>

      <h1 className="page-header mb-3">Configuración</h1>

      {/* Preferencias generales */}
      <div className="row">
        <div className="col-xl-6">
          <div className="card border-0 mb-3 shadow-sm">
            <div className="card-body">
              <b className="d-block mb-3">Preferencias de interfaz</b>

              <div className="mb-3">
                <label className="form-label">Tema</label>
                <select className="form-select" defaultValue="auto" disabled>
                  <option value="auto">Automático</option>
                  <option value="light">Claro</option>
                  <option value="dark">Oscuro</option>
                </select>
                <div className="small text-muted mt-1">
                  Próximamente: sincronización con el tema del sistema.
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Idioma</label>
                <select className="form-select" defaultValue="es-PE" disabled>
                  <option value="es-PE">Español (Perú)</option>
                  <option value="es-ES">Español (España)</option>
                  <option value="en-US">English (US)</option>
                </select>
              </div>

              <div className="form-check form-switch mb-3">
                <input className="form-check-input" type="checkbox" id="cfg-compact" />
                <label className="form-check-label" htmlFor="cfg-compact">
                  Densidad compacta
                </label>
              </div>

              <button className="btn btn-primary" disabled>
                Guardar preferencias
              </button>
            </div>
          </div>
        </div>

        {/* Notificaciones */}
        <div className="col-xl-6">
          <div className="card border-0 mb-3 shadow-sm">
            <div className="card-body">
              <b className="d-block mb-3">Notificaciones</b>

              <div className="form-check form-switch mb-3">
                <input className="form-check-input" type="checkbox" id="cfg-mail" defaultChecked />
                <label className="form-check-label" htmlFor="cfg-mail">
                  Enviar por correo
                </label>
              </div>

              <div className="form-check form-switch mb-3">
                <input className="form-check-input" type="checkbox" id="cfg-push" />
                <label className="form-check-label" htmlFor="cfg-push">
                  Enviar push
                </label>
              </div>

              <div className="form-check form-switch mb-4">
                <input className="form-check-input" type="checkbox" id="cfg-weekly" defaultChecked />
                <label className="form-check-label" htmlFor="cfg-weekly">
                  Resumen semanal
                </label>
              </div>

              <button className="btn btn-outline-primary" disabled>
                Actualizar notificaciones
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Integraciones (placeholder) */}
      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <b className="d-block mb-3">Integraciones</b>
          <div className="row g-3">
            <div className="col-md-4">
              <div className="border rounded p-3 h-100">
                <div className="fw-semibold mb-1">Azure AD</div>
                <div className="small text-muted mb-2">SSO corporativo</div>
                <button className="btn btn-sm btn-outline-secondary" disabled>
                  Conectar
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="border rounded p-3 h-100">
                <div className="fw-semibold mb-1">AWS S3</div>
                <div className="small text-muted mb-2">Carga de datasets</div>
                <button className="btn btn-sm btn-outline-secondary" disabled>
                  Configurar
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="border rounded p-3 h-100">
                <div className="fw-semibold mb-1">Elastika</div>
                <div className="small text-muted mb-2">Despliegues</div>
                <button className="btn btn-sm btn-outline-secondary" disabled>
                  Ver estado
                </button>
              </div>
            </div>
          </div>
          <div className="small text-muted mt-3">
            Próximamente: acciones reales y lectura de estados.
          </div>
        </div>
      </div>
    </div>
  );
}
